<template>
  <v-container
    id="shop-table"
    tag="section"
  >
    <base-material-card
      color="bgUser"
      icon="mdi-account"
      inline
      class="px-5 py-3"
    >
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light text-start v-card--material__heading mb-n6 v-sheet theme--dark elevation-6 bgUser pa-7">
          {{ title }}
        </div>
      </template>
      <v-row>
        <v-col
          cols="12"
          md="12"
        >
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            class="ml-auto"
            :label="$t('search')"
            hide-details
            single-line
            style="max-width: 250px;"
          />
        </v-col>
      </v-row>

      <v-divider class="mt-3" />

      <v-data-table
        :headers="localizationHeaders"
        :items="items"
        :search.sync="search"
        :sort-by="['userName']"
        :sort-desc="[false]"
        :loading="loading"
      >
        <template v-slot:top>
            <v-btn
            class="float-button"
              elevation="1"
              color="btnFloatColor"
              dark
              fab
              min-width="0"
              small
              @click="addUser"
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
        </template>
        <template v-slot:item.userName="{ item }">
          <router-link :to="{ name: 'user', params: { id: item.id }}">
            {{ item.userName }}
          </router-link>
        </template>
        <template v-slot:item.active="{ item }">
          {{ booleanFormat(item.active) }}
        </template>
        <template v-slot:item.actions="{ item }">
          <v-btn
            color="success"
            class="px-1 ml-1"
            fab
            x-small
          >
            <v-icon @click="editUser(item.id)">
              mdi-pencil
            </v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </base-material-card>

    <base-material-snackbar
      v-model="showErrorMessage"
      type="error"
      v-bind="{
        ['top']: true,
        ['center']: true,
        ['vertical']: true
      }"
    >
      {{ errorMessage }}
    </base-material-snackbar>
  </v-container>
</template>
<style>
.bgUser{
  background-color: #023A66 !important;
}
.float-button{
  float: right;
}
</style>
<script>
  import filters from '@/common/filters'
  import { repositoryFactory } from '@/api/repositoryFactory'
  const userRespository = repositoryFactory.get('users')

  export default {
    name: 'UserList',
    mixins: [filters],
    data: () => ({
      items: [],
      search: undefined,
      loading: false,
      showErrorMessage: false,
      errorMessage: '',
    }),
    computed: {
      title: {
        get () {
          return this.$t('users')
        },
      },
      localizationHeaders () {
        return [
          {
            text: this.$t('tables.users.userName'),
            value: 'userName',
          },
          {
            text: this.$t('tables.users.active'),
            value: 'active',
          },
          {
            sortable: false,
            text: this.$t('actions'),
            value: 'actions',
          },
        ]
      },
    },
    mounted () {
      var self = this
      self.loading = true
      userRespository.get().then(response => {
        if (response.data.isValid) {
          self.items = response.data.data
        } else {
          self.showErrorMessage = true
          self.errorMessage = response.data.errorMessages[0]
        }
        self.loading = false
      }).catch(err => {
        self.showErrorMessage = true
        if (err.response.status === 400) {
          self.showErrorMessage = err.response.data.errorMessages[0]
        } else {
          self.errorMessage = err
        }
        self.loading = false
      })
    },
    methods: {
      addUser () {
        this.$router.push({ name: 'user', params: { id: 'add' } })
      },
      editUser (id) {
        this.$router.push({ name: 'user', params: { id: id } })
      },
    },
  }
</script>
